import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { LocalStorage } from "../shared/wrappers/LocalStorage";

@Injectable()
export class AuthService {
    private endPoint = '/auth';
    constructor(private httpClient: HttpClient,
        private localStorage: LocalStorage) { }

    async auth(login) {
        const res = await this.httpClient.post(this.endPoint + '/office', login);
        if (res.success)
            this.localStorage.save(res.user, 'user');
        return res;
    }

    async oauthOffice365(){
        let res = await this.httpClient.get(`${this.endPoint}/oauth/365`);
        return res.url;
    }

    async refreshToken(username){
        return await this.httpClient.post(`${this.endPoint}/refresh-token`, username);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts